import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchMenuCounts } from '@/renderer/services/menuServicePaginated';

export function useMenuCounts(outletId?: string | null) {
  return useQuery({
    queryKey: queryKeys.menu.menuCounts(outletId),
    queryFn: async () => {
      // null/undefined outletId is a valid company-wide view (e.g. a super
      // user viewing "All Outlets"), not "not ready yet" — fetchMenuCounts
      // already handles it.
      const result = await fetchMenuCounts(outletId);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch menu counts');
      }
      return result.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}
